import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import { HttpService } from './http.service';
import {take} from 'rxjs';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  public brands: any[] = [];
  public types: any[] = [];
  public tags: any[] = [];
  public tagMap: Map<string, string> = new Map();
  public mwsPriceFormula = null;
  public shippingTags: any[] = [];
  public vendorTags: any[] = [];
  public users: any[] = [];

  constructor(
    private httpService: HttpService,
    private localStorageService: LocalStorageService,
  ) {
    this.brands = localStorageService.getItem('brands');
    this.types = localStorageService.getItem('types');
    this.tags = localStorageService.getItem('tags');
    this.shippingTags = localStorageService.getItem('shippingTags');
    this.users = localStorageService.getItem('users');
    this.vendorTags = localStorageService.getItem('vendorTags');
  }

  public getUsers(): void {
    this.users = this.localStorageService.getItem('users');
    this.httpService.get(environment.API_PATH + '/user/getUsers')
      .pipe(take(1))
      .subscribe((res: any) => {
        this.users = res;
        this.localStorageService.setItem('users', res);
      });
  }

  public getBrands(): Promise<any> {
    this.brands = this.localStorageService.getItem('brands');
    return new Promise<any>((resolve) => {
      this.httpService.get(environment.API_PATH + '/brand')
        .pipe(take(1))
        .subscribe((res: any) => {
          this.brands = res;
          this.localStorageService.setItem('brands', res);
          resolve(res);
        });
    });
  }

  public getTypes(): Promise<any> {
    this.types = this.localStorageService.getItem('types');
    return new Promise((resolve) => {
      this.httpService.get(environment.API_PATH + '/type').subscribe((types: any) => {
        this.types = types;
        this.localStorageService.setItem('types', types);
        resolve(types)
      });
    });
  }

  public getTags(): Promise<any> {
    const cachedTags = this.localStorageService.getItem('tags');
    this.tags = cachedTags;

    return new Promise((resolve, reject) => {
      this.httpService.get(environment.API_PATH + '/tag').subscribe({
        next: (tags: any) => {
          this.tags = tags;
          this.tagMap = new Map(tags.map((t: any) => [t._id, t.name]));
          this.localStorageService.setItem('tags', tags);
          resolve(tags);
        },
        error: (error: any) => {
          console.error('StorageService.getTags() HTTP error:', error);
          // Fall back to cached tags if HTTP request fails
          if (cachedTags && Array.isArray(cachedTags)) {
            console.log('StorageService.getTags() falling back to cached tags:', cachedTags.length);
            resolve(cachedTags);
          } else {
            console.warn('StorageService.getTags() no cached tags available');
            resolve([]); // Return empty array instead of rejecting
          }
        }
      });
    });
  }

  public getAiCategorisation(data: any): Promise<any> {
    return new Promise(resolve => {
      this.httpService.post(environment.API_PATH + '/product/old-structure', {
        skip: data.skip,
        limit: data.limit,
      }).subscribe((response: any) => {
        resolve(response);
      });
    });
  }

  public getMwsPriceFormula(): Promise<any> {
    this.mwsPriceFormula = this.localStorageService.getItem('mwsPriceFormula');
    return new Promise(resolve => {
      this.httpService.get(environment.API_PATH + '/feed/rule/mws_sell_price').subscribe((res: any) => {
        this.mwsPriceFormula = res.rule;
        this.localStorageService.setItem('mwsPriceFormula', res.rule);
        resolve(res.rule);
      });
    });
  }

  public getShippingTags(): Promise<any> {
    this.shippingTags = this.localStorageService.getItem('shippingTags');
    return new Promise(resolve => {
      this.httpService.get(environment.API_PATH + '/tag/shipping').subscribe((tags: any) => {
        this.shippingTags = tags;
        this.localStorageService.setItem('shippingTags', tags);
        resolve(tags);
      });
    });
  }

  public getVendorTags(): Promise<any> {
    this.vendorTags = this.localStorageService.getItem('vendorTags');
    return new Promise(resolve => {
      this.httpService.get(environment.API_PATH + '/tag/vendor').subscribe((tags: any) => {
        this.vendorTags = tags;
        this.localStorageService.setItem('vendorTags', tags);
        resolve(tags);
      });
    });
  }
}
